<script setup>
import AppIcon from './AppIcon.vue'
import { useToast } from '../composables/useToast'

const { state, remove } = useToast()
</script>

<template>
  <div class="toast-region" role="region" aria-label="Уведомления">
    <TransitionGroup name="toast">
      <div v-for="toast in state.items" :key="toast.id" class="toast" :class="`toast--${toast.tone}`" role="status">
        <span class="toast-icon" aria-hidden="true"><AppIcon :name="toast.tone === 'error' ? 'ban' : 'check'" :size="17" /></span>
        <span>{{ toast.message }}</span>
        <button type="button" class="toast-close" aria-label="Закрыть уведомление" @click="remove(toast.id)">
          <AppIcon name="close" :size="16" />
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>
